import { render, staticRenderFns } from "./test_report.vue?vue&type=template&id=6481b335&scoped=true"
import script from "./test_report.vue?vue&type=script&lang=js"
export * from "./test_report.vue?vue&type=script&lang=js"
import style0 from "./test_report.vue?vue&type=style&index=0&id=6481b335&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6481b335",
  null
  
)

export default component.exports